import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './lib/auth'
import { startAppUpdates } from './lib/app-update'
import App from './App'
import './index.css'

// The build this page booted: index.html's own entry script, read before anything else can touch the DOM. Only
// the production entry is emitted under /assets/, so a dev page never flags an update. lib/app-update.ts compares
// it with the deployed build, registers the service worker, and raises the new-version notice (never a reload).
const running =
  document.querySelector('script[type="module"][src^="/assets/"]')?.getAttribute('src') ?? new URL(import.meta.url).pathname
if (import.meta.env.PROD) startAppUpdates(running)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
